var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

if (navigator.platform.match('Mac') !== null || isIOS) {
  $("body").addClass("mac");
} else {
  $("body").addClass("Win");
}
